import './form-steps.scss';

import classNames from 'classnames';

import { checkIcon } from '@/constants';

type TProps = {
  currentStep: number;
  steps: Array<{
    title: string;
    totalFields: number;
    validFields: number;
  }>;
  onChange: (step: number) => void;
  isNextClickable?: boolean;
};

const FormSteps: React.FC<TProps> = ({ currentStep, steps, onChange }) => {
  const width = (100 * currentStep) / steps.length;

  return (
    <div className="form-steps">
      <div className="form-steps__header">
        <p>
          Шаг {currentStep} из {steps.length}
        </p>
      </div>
      <span
        // @ts-ignore
        style={{ '--width': width }}
        className="form-steps__progress"
      ></span>

      <div className="form-steps__body">
        {steps.map((step, i) => (
          <div
            className={classNames('form-steps__step', {
              'form-steps__step--active': currentStep === i + 1
            })}
            key={step.title}
            onClick={() => onChange(i)}
          >
            {i + 1 < currentStep ? (
              <img className="form-steps__check" src={checkIcon} />
            ) : (
              <span className="form-steps__circle"></span>
            )}
            <p
              className={classNames('form-steps__text', {
                'form-steps__text--gray': currentStep < i + 1
              })}
            >
              {step.title} ({step.validFields}/{step.totalFields})
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FormSteps;
